import { render, staticRenderFns } from "./CadastrarTituloHelp.vue?vue&type=template&id=8cfe0ca4"
import script from "./CadastrarTituloHelp.vue?vue&type=script&lang=js"
export * from "./CadastrarTituloHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports